(function () {
  'use strict';

  /* ── Announcement bar height CSS variable ──────────────────────────────────
   * Sets --mn-announcement-height on :root so navigation CSS can offset:
   *   - .menu-drawer__navigation-container padding-top (drawer aligns with nav)
   *   - .mn-mobile-search top (search overlays sticky-header, not announcement)
   * Updated on resize and when the announcement bar is dismissed.
   * ─────────────────────────────────────────────────────────────────────── */
  function setAnnouncementHeight() {
    var bar = document.getElementById('Announcement-header');
    var h = (bar && bar.offsetHeight > 0) ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--mn-announcement-height', h + 'px');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setAnnouncementHeight);
  } else {
    setAnnouncementHeight();
  }
  window.addEventListener('resize', setAnnouncementHeight);

  /* Watch for announcement bar dismissal (attribute change or removal from DOM) */
  var announcementBar = document.getElementById('Announcement-header');
  if (announcementBar) {
    new MutationObserver(setAnnouncementHeight).observe(announcementBar, {
      attributes: true, childList: false, subtree: false
    });
    if (announcementBar.parentNode) {
      new MutationObserver(setAnnouncementHeight).observe(announcementBar.parentNode, {
        childList: true
      });
    }
  }

  /* Watch body for shopify-section-header-hidden class (Shopify hides header on scroll) */
  new MutationObserver(setAnnouncementHeight).observe(document.body, {
    attributes: true, attributeFilter: ['class']
  });

  /* ── Drawer open/close body class + fix drawer items ──────────────────── */
  var drawer = document.querySelector('.mobile-menu-drawer');
  if (drawer) {
    function fixDrawerItems() {
      var items = document.querySelectorAll('#menu-drawer .menu-drawer__menu-item');
      items.forEach(function (li) {
        li.style.setProperty('height', 'auto', 'important');
        li.style.setProperty('overflow', 'visible', 'important');
        li.style.setProperty('max-height', 'none', 'important');
        li.style.setProperty('line-height', 'normal', 'important');
      });
      var links = document.querySelectorAll('#menu-drawer .mn-drawer-link');
      links.forEach(function (el) {
        el.style.setProperty('display', 'flex', 'important');
        el.style.setProperty('width', '100%', 'important');
        el.style.setProperty('height', 'auto', 'important');
        el.style.setProperty('overflow', 'visible', 'important');
        el.style.setProperty('align-items', 'center', 'important');
        el.style.setProperty('gap', '12px', 'important');
        el.style.setProperty('padding', '14px 0', 'important');
        el.style.setProperty('line-height', '1.4', 'important');
        el.style.setProperty('font-size', '15px', 'important');
      });
      var texts = document.querySelectorAll('#menu-drawer .mn-drawer-link__text');
      texts.forEach(function (el) {
        el.style.setProperty('flex', '1 1 auto', 'important');
        el.style.setProperty('overflow', 'visible', 'important');
        el.style.setProperty('white-space', 'normal', 'important');
        el.style.setProperty('font-size', '15px', 'important');
        el.style.setProperty('line-height', '1.4', 'important');
        el.style.setProperty('height', 'auto', 'important');
      });
      var chevrons = document.querySelectorAll('#menu-drawer .mn-drawer-link__chevron');
      chevrons.forEach(function (el) {
        el.style.setProperty('flex', '0 0 16px', 'important');
        el.style.setProperty('width', '16px', 'important');
        el.style.setProperty('height', '16px', 'important');
        el.style.setProperty('min-width', '16px', 'important');
      });
      var summaries = document.querySelectorAll('#menu-drawer .mn-drawer-summary');
      summaries.forEach(function (el) {
        el.style.setProperty('display', 'block', 'important');
        el.style.setProperty('width', '100%', 'important');
        el.style.setProperty('height', 'auto', 'important');
        el.style.setProperty('overflow', 'visible', 'important');
        el.style.setProperty('list-style', 'none', 'important');
      });
    }

    var drawerObserver = new MutationObserver(function () {
      if (drawer.hasAttribute('open')) {
        document.body.classList.add('mn-drawer-open');
        fixDrawerItems();
        setTimeout(fixDrawerItems, 50);
        setTimeout(fixDrawerItems, 200);
      } else {
        document.body.classList.remove('mn-drawer-open');
      }
    });
    drawerObserver.observe(drawer, { attributes: true, attributeFilter: ['open'] });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixDrawerItems);
    } else {
      fixDrawerItems();
    }
  }

  /* ── Tab active state on page load ──────────────────────────────────────── */
  document.onreadystatechange = function () {
    if (document.readyState === 'interactive') {
      var path = window.location.pathname;
      var tabs = document.querySelectorAll('[aria-label="Navigation Categories"] button');
      for (var i = 0; i < tabs.length; i++) {
        if (path.includes(tabs[i].textContent.trim().toLowerCase()) && !path.includes('womens')) {
          setTimeout(function (btn) { btn.click(); }.bind(null, tabs[i]), 50);
        }
      }
    }
  };

  /* ── Forward non-Algolia search forms to the Algolia-initialised form ── */
  /* CSS variable --aa-detached-media-query:all forces aa-DetachedSearchButton to be
     injected on every viewport. Algolia initialises on whichever form has
     algolia-search-form first in DOM (drawer on mobile, header on desktop via class swap).
     We search both containers so forwarding works regardless of which form got it. */
  function findDetachedBtn() {
    return document.querySelector('.mn-drawer-search .aa-DetachedSearchButton')
        || document.querySelector('.mn-search-wrap .aa-DetachedSearchButton');
  }
  document.addEventListener('click', function (e) {
    var inStacked = e.target.closest('.mn-mobile-search-bar .mn-search');
    var inDesktop = e.target.closest('.mn-search-wrap .mn-search');
    if (inStacked) {
      e.preventDefault();
      var btn = findDetachedBtn();
      if (btn) btn.click();
    } else if (inDesktop) {
      var btn = findDetachedBtn();
      if (btn) { e.preventDefault(); btn.click(); }
    }
  }, false);

  /* ── Rotating search placeholder ──────────────────────────────────────── */
  var config = window.MNNav || {};
  var placeholders = config.placeholders || [];
  if (placeholders.length >= 2) {
    var inputs = document.querySelectorAll('.mn-search__rotating');
    if (inputs.length) {
      var idx = 0;
      setInterval(function () {
        idx = (idx + 1) % placeholders.length;
        inputs.forEach(function (el) {
          if (el !== document.activeElement) {
            el.setAttribute('placeholder', placeholders[idx]);
          }
        });
      }, 3000);
    }
  }
})();
